import logger from '@finn-no/fiaas-logger';
import type { GetServerSidePropsContext, GetServerSidePropsResult, NextPage } from 'next';
import { getPageCounter } from 'shared/prometheus/prometheus';
import { fetchOffer } from '@/api/fetcher';
import { Out, type OutProps } from '@/components/outpage/Out';
import { config, feConfig } from '@/config';

const OutPage: NextPage<OutProps> = (props: OutProps) => <Out {...props} vertical="pp" />;

// biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
export const getServerSideProps = async ({ query }: GetServerSidePropsContext): Promise<GetServerSidePropsResult<any>> => {
    try {
        const data = await fetchOffer(config.get('pp.apiUrlInternal'), query);

        getPageCounter().inc({ app: 'pale-pp-web', page: 'ut' });

        return {
            props: {
                ...data,
                // Must be set to null specifically, as undefined cannot be serialized (which is done when sending data to the client)
                fromPage: query.fromPage ?? null,
                numberOfAdults: query.numberOfAdults ?? null,
                agesOfChildren: query.agesOfChildren ?? null,
                deepLink: data?.deepLink ?? null,
                config: feConfig,
            },
        };
    } catch (error) {
        logger.error(`Failed to fetch offer for out page: ${error}`);
        return { props: { config: feConfig } };
    }
};

export default OutPage;
